import React, { useEffect, useState } from 'react';
import { X, Info, AlertTriangle, CheckCircle, AlertCircle } from 'lucide-react';
import axiosInstance from '../api/axiosInstance';
import './SystemStatusBanner.css';

const BANNER_CONFIG = {
  INFO:    { icon: Info,          color: '#1565C0', bg: '#EFF6FF', border: '#BFDBFE' },
  WARNING: { icon: AlertTriangle, color: '#D97706', bg: '#FFFBEB', border: '#FDE68A' },
  ERROR:   { icon: AlertCircle,   color: '#DC2626', bg: '#FEF2F2', border: '#FECACA' },
  SUCCESS: { icon: CheckCircle,   color: '#059669', bg: '#ECFDF5', border: '#A7F3D0' },
};

const SystemStatusBanner = () => {
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    fetchStatus();
  }, []);

  const fetchStatus = async () => {
    try {
      const res = await axiosInstance.get('/system/status');
      if (res.data.success) {
        const s = res.data.data;
        if (s.statusBannerEnabled && s.statusBannerMessage) {
          setBanner({ message: s.statusBannerMessage, type: s.statusBannerType || 'INFO' });
        }
      }
    } catch (e) {}
  };

  if (!banner || dismissed) return null;

  const config = BANNER_CONFIG[banner.type] || BANNER_CONFIG.INFO;
  const Icon = config.icon;

  return (
    <div className="system-status-banner" style={{ background: config.bg, borderColor: config.border }}>
      <div className="system-status-banner-inner">
        <Icon size={16} color={config.color} style={{ flexShrink: 0 }} />
        <p className="system-status-banner-text" style={{ color: config.color }}>
          {banner.message}
        </p>
        <button className="system-status-banner-close" onClick={() => setDismissed(true)} style={{ color: config.color }}>
          <X size={14} />
        </button>
      </div>
    </div>
  );
};

export default SystemStatusBanner;